import { render, staticRenderFns } from "./TaskManagment.vue?vue&type=template&id=621d065f&scoped=true"
import script from "./TaskManagment.vue?vue&type=script&lang=js"
export * from "./TaskManagment.vue?vue&type=script&lang=js"
import style0 from "./TaskManagment.vue?vue&type=style&index=0&id=621d065f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621d065f",
  null
  
)

export default component.exports